import * as React from 'react';
import { connect } from 'react-redux';
import { ServiceTile as ServiceTileComponent } from 'components/serviceTile';
import { getTelemetryDetailContentCurrentView } from '@shared/utils/appUtils';
import { createSetCheckoutSource } from '@shared/actions/checkoutActions';
import { CheckoutSource } from '@shared/Models';
const mapStateToProps = (state, ownProps)=>{
    var _state_config, _state_config1, _state_config2, _state_config3, _state_users;
    return {
        currentView: getTelemetryDetailContentCurrentView((_state_config = state.config) === null || _state_config === void 0 ? void 0 : _state_config.currentView, (_state_config1 = state.config) === null || _state_config1 === void 0 ? void 0 : _state_config1.currentGalleryViewIsCurated),
        query: (_state_config2 = state.config) === null || _state_config2 === void 0 ? void 0 : _state_config2.query,
        isAppSource: (_state_config3 = state.config) === null || _state_config3 === void 0 ? void 0 : _state_config3.isAppSource,
        isLoadingUserData: (_state_users = state.users) === null || _state_users === void 0 ? void 0 : _state_users.loading,
        ribbonKey: ownProps.ribbonKey
    };
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        setTileCheckoutSource: ()=>dispatch(createSetCheckoutSource({
                source: CheckoutSource.Tile
            }))
    };
};
export const ServiceTile = connect(mapStateToProps, mapDispatchToProps)(ServiceTileComponent);
